// extracted by mini-css-extract-plugin
module.exports = {"bottomText":"_1oB8wG91SJqrFzZcNHEzh6","topText":"_26gWgE-fwlCSs47gg07X1T","small":"_1ug_xi9LLRU0MuGNeeXZnY","medium":"_3N20dfB-K638JNo4PTwq_j","large":"_3KwxC6ZLAxXj8emq3LweTy"};